import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router.js'
import store from '@/store.js'
import VueHead from 'vue-head'
import VeeValidate from 'vee-validate'
import UUID from 'vue-uuid'

Vue.use(VueHead)
Vue.use(VeeValidate)
Vue.use(UUID)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
